<app-card-widget title="Attachments (old)" *ngIf="invoice$ | async">

  <form [formGroup]="form" id="attachment-form" (ngSubmit)="save()" *ngIf="invoiceAttachmentTypesMap$ | async as map" novalidate>

    <div class="card-section-container">

      <div class="card-section" *ngIf="!added">

        <mat-nav-list>
          <mat-list-item *ngFor="let item of invoiceAttachments$ | async" (click)="itemClicked(item)" [class.mat-elevation-z2]="item === selectedItem">
            <mat-icon matListIcon>attachment</mat-icon>
            <h3 matLine>{{item.originalFileName}}</h3>
            <span matLine>{{map.get(item.invoiceAttachmentTypeId)?.description}}</span>
            <div class="list-item-timestamp">{{item.created | date:'short'}}</div>
          </mat-list-item>
        </mat-nav-list>

      </div>
      <div class="card-section" *ngIf="selectedItem && !added">

        <app-text label="Type" *ngIf="!edited">{{map.get(selectedItem.invoiceAttachmentTypeId)?.description}}</app-text>

        <mat-form-field *ngIf="edited">
          <mat-select placeholder="Type" formControlName="invoiceAttachmentTypeId">
            <mat-option *ngFor="let type of map.all()" [value]="type.invoiceAttachmentTypeId">
              {{type.description}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <app-text label="Original Filename">{{selectedItem.originalFileName}}</app-text>

        <app-text label="Description" *ngIf="!edited">{{selectedItem.description}}</app-text>

        <mat-form-field *ngIf="edited">
          <input matInput placeholder="Description" formControlName="description"/>
        </mat-form-field>

        <mat-form-field *ngIf="edited">
          <mat-select placeholder="Hidden" formControlName="isHidden">
            <mat-option *ngFor="let option of hiddenChoices" [value]="option.value">
              {{option.label}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <app-text label="Created">{{selectedItem.created | date:'medium'}}</app-text>

        <button *ngIf="!edited && !added" type="button" mat-icon-button (click)="download(selectedItem)" title="Download Attachment File">
          <mat-icon>cloud_download</mat-icon>
        </button>

      </div>

      <div class="card-section" *ngIf="added">
        <div class="drop-zone" appFileUpload (fileAdded)="uploadFileAdded($event)">
          <p>Drag and drop files here</p>
          <mat-icon>cloud_upload</mat-icon>
        </div>
      </div>

      <div class="card-section" *ngIf="added && uploadFiles.length > 0">
        <mat-list>
          <mat-list-item *ngFor="let f of uploadFiles">
            <mat-icon matListIcon>attachment</mat-icon>
            <span matLine>{{f.name}}</span>
            <button type="button" mat-icon-button (click)="removeUploadFile(f)" style="margin-left: 16px">
              <mat-icon>cancel</mat-icon>
            </button>
          </mat-list-item>
        </mat-list>
      </div>

    </div>

  </form>

  <mat-card-actions align="end">
    <button type="button" mat-button *ngIf="!edited && !added" [disabled]="locked" (click)="add()">Add</button>
    <button type="button" mat-button *ngIf="!edited && !added" [disabled]="locked || !selectedItem" (click)="edit()">Edit</button>
    <button type="submit" mat-button *ngIf="edited" [disabled]="!form.valid" form="attachment-form">Save</button>
    <button type="button" mat-button *ngIf="added" [disabled]="uploadFiles.length === 0 || saving" (click)="upload()">Save</button>
    <button type="reset" mat-button *ngIf="edited || added" (click)="revert()">Cancel</button>
  </mat-card-actions>

</app-card-widget>


